import * as actionTypes from './action-types';

export function setValidationErrors (errors) {
  return {
    type: actionTypes.SET_VALIDATION_ERRORS,
    payload: errors
  };
}

export function clearValidationErrors () {
  return {
    type: actionTypes.CLEAR_VALIDATION_ERRORS
  };
}



/** WEBPACK FOOTER **
 ** ./src/redux/modules/validation-errors/index.js
 **/